import React from 'react';
import '.././Styles/paymentsuccess.css';
import { Checkmark } from 'react-checkmark'


function App() {
  
    
	return (
		
        <div class="card">
            <Checkmark size='xxLarge' />
        <h1 class="center">Thank you.</h1>
        <h4 class="center">Your order has been placed successfully.</h4>
        <h4 class="center">We will immediatelly process your and it will be delivered in 30 minutes.</h4>
    </div>
          
    

		
	);
}
export default App;